import { rowText } from './scans';
import type { Scan } from './types';

interface Props {
  scans: Scan[];
  onSelect: (scan: Scan) => void;
}

/** One player's scans, newest first. Clicking a row finds its dot on the map. */
export function PlayerList({ scans, onSelect }: Props) {
  const sorted = [...scans].sort((a, b) => b.scannedAt - a.scannedAt);
  return (
    <ul className="player-list" aria-label="Scans by this player">
      {sorted.map((scan) => {
        const t = rowText(scan);
        return (
          <li key={scan.scanId}>
            <button type="button" className="player-list-row" onClick={() => onSelect(scan)}>
              <span className="when">{t.local}</span>
              <span className="what">{t.what}</span>
              {t.outcome && <span className={`outcome outcome-${scan.outcome}`}>{t.outcome}</span>}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
